
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createcontactoep9x4 } from '../../api/contactoep9x4.api'

import './contactoj8kuwg.scss';






const Pcontactoj8kuwg = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  
  
  

  
  return (
    <div id="id6898f6108e5aed52dc7b5679" >

      <div id="ibm6" className="">
      
      <div id="iwqt" className="">
      
      <div id="incm3" className="">
      
        <a
          target=""
          className=""
          id="ixtof"
          href="/"
        >
          
      <img
        className=""
        id="iwbnr"
        src="https://assetsprojects.s3.amazonaws.com/404pziime609rgd.png"
        alt="undefined"
      />
      
        </a>
        
      <div id="id16m" className="">
      
        <a
          target=""
          className="link-menu "
          id="ikbb5"
          href="/"
        >
          
    <div id="i5zvy" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iaz2n"
          href="/informacion"
        >
          
    <div id="igsoz" className="">
    <>Nuestra información</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ijoly"
          href="/quehacemos"
        >
          
    <div id="i1fz4" className="">
    <>Que Hacemos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i6wju"
          href="/guiadigital"
        >
          
    <div id="iu68s" className="">
    <>Guía Digital</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu link-activo "
          id="iqw23"
          href="/contacto"
        >
          
    <div id="i97f5" className="">
    <>Contacto</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="inx9l"
          href="https://hackathon.sustentahonduras.org/"
        >
          
    <div id="iosi8" className="">
    <>Hackathon</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i2zb" className="">
      
      <div
        id="iqf8z"
        className=""
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="izgm8" className="">
      
      <div id="ix4ee" className="">
      
      <div className="" id="iqji1">
        <>Contáctanos</>
      </div>
      
        <div className="" id="i31hij">
          
      <form
        id="i0d1ph"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createcontactoep9x4({
						token: 'aasdas',
						nombren2be6: e.target.nombren2be6.value,
						telefono09c7u: e.target.telefono09c7u.value,
					});
					alert("Se enviaron los datos de manera exitosa.");
		} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="ih4xft" className="">
      
      <label id="" className="">
      <>Nombre</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="nombren2be6"
        type="text"
        placeholder="Nombre"
        className="input "
        id="irg9tk"
      />
      
      </div>
      
      <div id="ipxiwl" className="">
      
      <label id="" className="">
      <>Telefono</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="telefono09c7u"
        type="text"
        placeholder="Telefono"
        className="input "
        id="ibz5dy"
      />
      
      </div>
      
    <div id="i7f1ao" className="">
    
      <label id="" className="">
      <>Mensaje</>
      </label>
      
      <br className="" id="" />
      
      <textarea name="mensajenba8f" className="input " id="iwxl4g">
        
      </textarea>
      
    </div>
    
      <div id="i84g83" className="">
      
      <button
        type="submit"
        name=""
        id="iaejqa"
        className="boton-principal "
        
      >
      
      <div id="i8yr2j" className="">
      <>Enviar</>
      </div>
      
      </button>
      
      </div>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ib7vm" className="">
      
      <div id="i2r5z" className="">
      
      <div id="ii5r3" className="">
      
      <div
        id="izcvk"
        className="tarjeta-alianza "
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="ik3bo" className="">
      
      <img
        className=""
        id="iyh5u"
        src="https://assetsprojects.s3.amazonaws.com/404pziime60yov9.png"
        alt="undefined"
      />
      
      <div className="" id="ipzze">
        <>Insert your text here</>
      </div>
      
      </div>
      
      <div id="i7znk" className="">
      
      <div className="" id="iuqiz">
        <>Cipotes Honduras</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iss5" className="">
      
      <div id="izyl6q" className="">
      
      <div className="" id="iwoln1">
        <>Todos los Derechos Reservadost © 2025 Jovenes al Voto</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcontactoj8kuwg);
  